import { ACCESS_TOKEN, REFRESH_TOKEN } from "../constants/app.constants";
import { nanoid } from "nanoid";

import CryptoJS from "crypto-js";

export const isLoggedInUser = () => !!localStorage.getItem(ACCESS_TOKEN);

export const getDomainName = (givenUrl) => {
    const splitUrl =  givenUrl.split("/");
    return splitUrl[2];
}

export const replaceDomainName = (newDomainName, givenUrl) =>{
    const oldDomainName =  getDomainName(givenUrl);
    const newUrl = givenUrl.replace(oldDomainName, newDomainName);
    if(newUrl.includes("https")) {
        return newUrl;
    }
    return `https:${newUrl}`;

}

export const encryptData = (word) =>{
  const keyBase64 = "o9szYIOq1rRMiouNhNvaq96lqUvCekxR";
  var key = CryptoJS.enc.Base64.parse(keyBase64);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  return encrypted.toString();
}

export const encryptWithAES = (text) => {
    if(!text){
        return text;
    }
    const passphrase = "gjhgjhgjhgtyjt768756875#^%#^%#&%";
    return CryptoJS.AES.encrypt(text, passphrase).toString();
};
  
export const decryptWithAES = (ciphertext) => {
    if(!ciphertext){
        return ciphertext;
    }
    const passphrase = "gjhgjhgjhgtyjt768756875#^%#^%#&%";
    const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  };
  

   

